import {Box, Typography} from "@mui/material";

function UXLoginReset() {

    return (
        <Box>
            <Typography variant="h4">Login Reset</Typography>
        </Box>
    )
}

export default UXLoginReset

